module.exports = __webpack_public_path__ + "media/images/countryrect/pw-5759a5a178dafea31e94767a9c952cca.svg";